var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import gql from "graphql-tag";
import * as React from "react";
import Select from "react-select";
import { OrganizationRole } from "./admin-gql";
import { getRoleDisplayNames } from "./displayNames";
export var SelectOrganizationRole = function (props) {
    return (React.createElement(Select, { styles: {
            control: function (provided, state) { return (__assign(__assign({}, provided), { minHeight: null, height: 33.5 })); },
        }, options: Object.keys(OrganizationRole)
            .filter(function (key) { return !props.disableMemberRole || key !== OrganizationRole.USER; })
            .map(function (x) { return ({
            label: getRoleDisplayNames(x) || x,
            value: x,
        }); }), value: props.role
            ? {
                value: props.role,
                label: getRoleDisplayNames(props.role) || props.role,
            }
            : null, isDisabled: props.disabled || props.readonly, onChange: function (option) { return props.onChange(option.value); } }));
};
// Make sure we generate the OrganizationRole enum
export var mygql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Dummy on User {\n    role\n  }\n"], ["\n  fragment Dummy on User {\n    role\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=SelectOrganizationRole.js.map